import {
  RechargeCommissionRuleV2,
  RechargeCommissionRuleV2Response,
  RechargeCommissionRuleThresholds,
} from '../invitation.type';

export interface NormalizedRechargeCommissionRuleData
  extends RechargeCommissionRuleThresholds {
  rechargeRuleGroups: RechargeCommissionRuleV2[];
}

export const normalizeRechargeCommissionRuleResponse = (
  response?: RechargeCommissionRuleV2Response,
): NormalizedRechargeCommissionRuleData => {
  const isV1Response = Array.isArray(response);
  const ruleGroups = isV1Response ? response : response?.list || [];

  return {
    betCommissionBetThreshold: isV1Response
      ? undefined
      : response?.betCommissionBetThreshold,
    betCommissionRechargeThreshold: isV1Response
      ? undefined
      : response?.betCommissionRechargeThreshold,
    betThreshold: isV1Response ? undefined : response?.betThreshold,
    rechargeRuleGroups: ruleGroups
      .filter(item => item.list?.length || item.gameList?.length)
      .sort((a, b) => a.agentLevel - b.agentLevel),
    rechargeCommissionBetThreshold: isV1Response
      ? undefined
      : response?.rechargeCommissionBetThreshold,
    rechargeCommissionRechargeThreshold: isV1Response
      ? undefined
      : response?.rechargeCommissionRechargeThreshold,
    rechargeThreshold: isV1Response ? undefined : response?.rechargeThreshold,
  };
};

export const formatCashbackThreshold = (threshold?: number) => {
  if (typeof threshold !== 'number' || !Number.isFinite(threshold)) {
    return undefined;
  }

  return threshold.toLocaleString('en-IN', {
    maximumFractionDigits: 2,
  });
};

export const getAgentCommissionRuleGroup = (
  ruleGroups: RechargeCommissionRuleV2[] | undefined,
  agentLevel: number | undefined,
) => {
  const normalizedAgentLevel = Number(agentLevel);
  const currentAgentLevel =
    Number.isFinite(normalizedAgentLevel) && normalizedAgentLevel > 0
      ? normalizedAgentLevel
      : 1;

  return (ruleGroups || []).find(
    group => group.agentLevel === currentAgentLevel,
  );
};
